import React from "react";
import {IconButton, Tooltip} from "@mui/material";
import OpenInNew from "@mui/icons-material/OpenInNew";
import NoteAddOutlined from "@mui/icons-material/NoteAddOutlined";
import {useNavigate} from "react-router-dom";
import {HwOpening} from "../../../../api/Hardware";
import {useProjectId} from "../ProjectName";
import {useIsQuote} from "../../quote/QuoteContainer";
import {useAlternative} from "../../quote/alternative/Alternative";
import {hardwareElevationToolUrl, openElevation} from "../openings/elevationToolLink";

// the hardware elevation link beside a hardware heading: the first listed opening's elevation
// name and an icon that opens that opening in the elevation tool's hardware workspace. The icon
// is disabled when the heading has no openings.
export function HwGroupElevationLink(props: {openings: Pick<HwOpening, "id" | "drwHardwareElevation" | "drwHardwareElevationName">[]}) {
    const project = useProjectId();
    const isQuote = useIsQuote();
    const alternative = useAlternative();
    const nav = useNavigate();

    const first = props.openings.length > 0 ? props.openings[0] : null;
    const hasElevation = !!first?.drwHardwareElevation;
    const url = first ? hardwareElevationToolUrl({
        project,
        opening: first.id,
        alternative: isQuote ? alternative : undefined,
    }) : undefined;

    let title = "No openings";
    if(first) title = hasElevation ? "Open in elevation tool" : "Draw new elevation";

    return (
        <div style={{display: "flex", alignItems: "center", gap: 4, fontWeight: "normal"}}>
            {hasElevation && <span>{first?.drwHardwareElevationName || ""}</span>}
            <Tooltip title={title}>
                <span>
                    <IconButton
                        size="small"
                        style={{height: 16}}
                        disabled={!url}
                        component="a"
                        href={url}
                        onClick={(e: React.MouseEvent) => url && openElevation(e, nav, url)}
                    >
                        {hasElevation ? <OpenInNew fontSize="inherit" /> : <NoteAddOutlined fontSize="inherit" />}
                    </IconButton>
                </span>
            </Tooltip>
        </div>
    );
}
